import Title from './title/title.vue'
import Text from './text/text.vue'
import Banner from './banner/banner.vue'
import Image from './image/image.vue'
import Gradient from './gradient/gradient.vue'
import Player from './player/player.vue'
import Button from './button/button.vue'
import Icon from './icon/icon.vue'
import Overlay from './overlay/overlay.vue'
import Ct from './disposition/ct.vue'
import Row from './disposition/row.vue'
import Col from './disposition/col.vue'
import SocialPostsCarousel from './social-posts-carousel/social-posts-carousel.vue'
import SafetyDatasheet from './safety-datasheet/safety-datasheet.vue'
import EventCard from './event-carousel/event-card.vue'
import EventDropdown from './event-carousel/event-dropdown.vue'
import EventCarousel from './event-carousel/event-carousel.vue'
import TextWithSvgIcon from './text-with-svg-icon/text-with-svg-icon.vue'

export default [
  Title,
  Text,
  Banner,
  Image,
  Gradient,
  Player,
  Button,
  Icon,
  Overlay,
  Ct,
  Row,
  Col,
  SocialPostsCarousel,
  SafetyDatasheet,
  EventCard,
  EventCarousel,
  EventDropdown,
  TextWithSvgIcon,
]
